import moment from 'moment/moment'

import { FORMAT_DATE, ISO_FORMAT_DATE } from './constants'

export default function ISODateFormat(date, format = FORMAT_DATE) {
  if (!date) return null
  return moment(date, ISO_FORMAT_DATE).format(format)
}
